var exports = {
  "sx": "xf0b3b88a--efefec--underground-container",
  "Pt": "xf0b3b88a--efefec--icons",
  "Oz": "xf0b3b88a--efefec--underground-name",
  "y_": "xf0b3b88a--efefec--remoteness",
  "DQ": "xf0b3b88a--efefec--address-links",
  "V": "xf0b3b88a--efefec--underground-link",
  "Cp": "xf0b3b88a--efefec--address-link",
  "Fp": "xf0b3b88a--efefec--link-container",
};

module.exports = exports;
